
import * as React from "react";
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import i18next from 'i18next';
import  { useEffect } from 'react';
import 'react-calendar/dist/Calendar.css';
import 'react-datepicker/dist/react-datepicker.css';
import { ErrorBoundary } from 'react-error-boundary';
import { I18nextProvider } from 'react-i18next';
import 'react-perfect-scrollbar/dist/css/styles.css';
import 'react-phone-input-2/lib/style.css';
import { BrowserRouter } from 'react-router-dom';
import AppSnackBar from './Components/AppSnackbar';
import MainLayout from './Containers/MainLayout';
import KenLoader from './GlobalComponents/KenLoader';
import { AppContextProvider } from './Helpers/Contexts/appContext';
import { AuthContextProvider } from './Helpers/Contexts/authContext';
import { FormContextProvider } from './Helpers/Contexts/formContext';
import { SearchContextProvider } from './Helpers/Contexts/searchContext';
import { EventContextProvider } from './Helpers/Contexts/eventContext';
import ErrorFallback from './Helpers/ErrorFallback';
import GlobalThemeProvider from './Helpers/Themes/themeProvider';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { FileUploadContext } from './Containers/VenuePortal/src/contexts/FileUploadContext';
import { IonApp } from '@ionic/react';
import { setupIonicReact } from '@ionic/react';
import storageService from './Utils/storageService';

/* Import Global Styles including General Sans font */
import './theme/variables.css';

setupIonicReact();

function App() {
  const queryClient = new QueryClient();


  return (
    <BrowserRouter>
      <IonApp>
        <QueryClientProvider client={queryClient}>
          <React.Suspense fallback={<KenLoader />}>
            <FileUploadContext>
              <AppContextProvider>
                <AuthContextProvider>
                  <SearchContextProvider>
                    <EventContextProvider>
                      <LocalizationProvider dateAdapter={AdapterMoment}>
                        <FormContextProvider>
                          <AppSnackBar>
                            <GlobalThemeProvider>
                              <I18nextProvider i18n={i18next}>
                              <ErrorBoundary
                                FallbackComponent={ErrorFallback}
                                onReset={() => {
                                  window.location.reload();
                                }}
                              >
                                <div className="App">
                                  <MainLayout />
                                </div>
                              </ErrorBoundary>
                            </I18nextProvider>
                          </GlobalThemeProvider>
                        </AppSnackBar>
                      </FormContextProvider>
                    </LocalizationProvider>
                  </EventContextProvider>
                </SearchContextProvider>
              </AuthContextProvider>
            </AppContextProvider>
            </FileUploadContext>
          </React.Suspense>
        </QueryClientProvider>
      </IonApp>
    </BrowserRouter>
  );
}

export default App;
